__webpack_require__.p = "https://staging.guild.host/assets/";